<div class="mb-5 mt-4 border-1 border-gray-300 shadow-xl bg-white dark:bg-gray-900 rounded-xl">
  <p class="text-3xl font-extrabold tracking-normal hover:text-blue-500 dark:text-white text-black p-3 px-4">
    <mat-icon class="mt-2" [inline]="true" *ngIf="showIcon">
      {{icon}}
    </mat-icon>
    {{heading}}
  </p>
  <!-- <mat-card-subtitle *ngIf="subheading">{{subheading}}</mat-card-subtitle> -->
  <hr *ngIf="showButton || showDownloadButton">
  <!-- Comentario antiguo (dejo para la posteridad... cambié la línea pero no quiero apropiarme de la autoría del comentario)
  <hr *ngIf="showButton"> <!-- si pongo dentro del div de abajo no aparece😡 -->
  <div class="flex items-start gap-5 mt-2 p-3 px-4" *ngIf="showButton || showDownloadButton">
    <button  *ngIf="showButton"
      class="py-4 px-4 h-10 w-auto inline-flex items-center justify-center text-center text-base bg-green-600 text-white hover:bg-opacity-90 font-normal rounded-full"
      (click)="clicked.emit(true)">
      <mat-icon class="mr-2">add</mat-icon>
      Nuevo registro
    </button>
    <button  *ngIf="showDownloadButton"
      class="py-4 px-4 h-10 w-auto inline-flex items-center justify-center text-center text-base bg-gray-800 text-white hover:bg-opacity-90 font-normal rounded-full"
      (click)="downloadClicked.emit(true)">
      <mat-icon class="mr-2">download</mat-icon>
      {{downloadButtonText}}
    </button>
  </div>
</div>